import { Component } from '@angular/core';
import { AsahiFooterComponent } from '../asahi-footer/asahi-footer.component';
import { AsahiNavbarComponent } from '../asahi-navbar/asahi-navbar.component';
import { TranslatePipe } from '@ngx-translate/core';
import { LeadService } from '../../../service/lead.service';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-asahi-premium-cal-details',
  imports: [AsahiFooterComponent,AsahiNavbarComponent,TranslatePipe,CommonModule],
  templateUrl: './asahi-premium-cal-details.component.html',
  styleUrl: './asahi-premium-cal-details.component.scss'
})
export class AsahiPremiumCalDetailsComponent {
  // ---------- Constructor ----------
  constructor(private leadService: LeadService,private router: Router,
      private _actRoute: ActivatedRoute
  ) {}

  // To store response data
  responseData!:number| null;

    /** Current query */
  private currentQueryParams: any = {};

  /** Current language */
  private currentLang!: string ;

  // Angualr Hooks
  ngOnInit() {
    this.responseData = this.leadService.getResponseData();
     this.currentLang = this.router.url.split('/')[1]; // 0: "income-protection-insurance", 1: "vi"
    console.log('Lang from ActivatedRoute:', this.currentLang);
    this._actRoute.queryParams.subscribe((queryParams) => {
      this.currentQueryParams = { ...queryParams };
    });
  }
  // Get coverage navigation
  onCoverage() {
    const basePath = [this.router.url.split('/')[2]];
    this.router.navigate([this.currentLang, ...basePath], {
      queryParams: {
         ...this.currentQueryParams, 
          scrollTo: 'premium-cal' 
      }
    });
  }
}
